import { Pipe, PipeTransform } from "@angular/core";
import { Tools } from "@comunicare/comunicare-helper";
import { IVitalProfileDefinition } from "@comunicare/comunicare-interfaces";

/**
 * Returns the allowed range of a vital sign as a string (ex: "0 - 250", "≥ 0")
 * min defaults to 0 when not defined
 */
@Pipe({ name: "vitalSignRange" })
export class VitalSignRangePipe implements PipeTransform {
  public transform(def: IVitalProfileDefinition): string {
    const min = Tools.isDefined(def?.min) ? def.min : 0;
    return Tools.isDefined(def?.max) ? `${min} - ${def.max}` : `≥ ${min}`;
  }
}
